export enum MissingHealthCardReasons {
  NoCard = 'NO_CARD',
  NotWithCard = 'NOT_WITH_CARD',
}
